import React, { useEffect, useMemo, useState } from 'react';
import './styles.css';
import Slide, { SlideProps } from './Slide';

export type MediaSliderProps = {
  slides: SlideProps[]
};

const MediaSlider: React.FC<MediaSliderProps> = ({slides}) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  const slidesComps = useMemo(() => {
    let curr;

    slides?.forEach((slide, i) => {
      if(currentSlide === i) {
        curr = (
          <Slide {...slide} index={0} />
        );
      }
    });

    return curr || null;
  }, [
    slides, currentSlide
  ]);

  useEffect(() => {
    const nextSlide = () => {
      setCurrentSlide(currentSlide + 1 <= slides?.length - 1 ? (currentSlide + 1) : 0)
    };

    const intr = setInterval(() => nextSlide(), 5000);

    return () => {
      clearInterval(intr);
    }
  }, [currentSlide, slides?.length])

  return (
    <div className='mediaslider'>
      {slidesComps}
    </div>
  );
}

export default MediaSlider;